/**
 * Expandable Cards Section - Pure Tailwind Version
 * Enhanced animations and functionality
 */

(function () {
  "use strict";

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    // Check if section exists
    const sections = document.querySelectorAll(".expandable-cards-section");

    if (sections.length === 0) {
      return;
    }

    initScrollAnimations();
    initExpandableCards();
    initCarousel();
  }

  function initScrollAnimations() {
    // Trigger animations when section comes into view
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              const section = entry.target;

              // Trigger fade animations
              const fadeUpElements = section.querySelectorAll(
                ".expandable-animate-fade-up"
              );
              fadeUpElements.forEach(function (el) {
                el.style.animationPlayState = "running";
              });

              // Observer can be disconnected once animations are triggered
              observer.unobserve(section);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: "50px",
        }
      );

      const sections = document.querySelectorAll(".expandable-cards-section");
      sections.forEach(function (section) {
        observer.observe(section);
      });
    }
  }

  // Add CSS styles for animations and proper card sizing
  const style = document.createElement("style");
  style.textContent = `
    /* Animation keyframes */
    @keyframes expandable-fadeInUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    /* Apply to elements with class */
    .expandable-animate-fade-up {
      animation: expandable-fadeInUp 0.8s ease-out forwards;
      animation-play-state: paused; /* Start paused, triggered by JS */
    }
    
    /* Enhanced card styling for expandable functionality */
    .expandable-cards-section {
      /* Section-specific styles */
    }
    
    .expandable-cards-section .cards-container {
      transition: transform 0.5s ease-in-out;
    }
    
    .expandable-cards-section .card-item {
      transition: all 0.7s ease-in-out;
      cursor: pointer;
    }
    
    .expandable-cards-section .card-item .expandable-content {
      max-height: 0;
      opacity: 0;
      overflow: hidden;
      transition: all 0.5s ease-in-out;
    }
    
    .expandable-cards-section .card-item.card-expanded .expandable-content {
      max-height: 600px !important;
      opacity: 1;
    }
    
    .expandable-cards-section .card-item .expand-icon {
      transform: rotate(0deg);
      transition: all 0.3s ease;
    }
    
    .expandable-cards-section .card-item .collapse-icon {
      transform: rotate(0deg);
      transition: all 0.3s ease;
      opacity: 0;
    }
    
    .expandable-cards-section .card-item.card-expanded .expand-icon {
      opacity: 0;
      transform: rotate(180deg);
    }
    
    .expandable-cards-section .card-item.card-expanded .collapse-icon {
      opacity: 1;
      transform: rotate(0deg);
    }
    
    /* Card size controls with updated dimensions */
    .expandable-cards-section .card-collapsed {
      width: 500px;
      min-width: 280px;
      max-width: 500px;
      flex-shrink: 0;
    }
    
    .expandable-cards-section .card-expanded {
      width: 500px;
      min-width: 280px;
      max-width: 900px;
      flex-shrink: 0;
      z-index: 10;
    }
    
    .expandable-cards-section .cards-container {
      display: flex !important;
      gap: 16px !important;
      transition: transform 0.5s ease-in-out !important;
      width: max-content !important;
    }
    
    .expandable-cards-section .cards-wrapper {
      overflow-x: hidden;
      width: 100%;
      scrollbar-width: none;
      -webkit-overflow-scrolling: touch;
    }
    
    /* Hide scrollbar for Chrome, Safari and Opera */
    .expandable-cards-section .cards-wrapper::-webkit-scrollbar {
      display: none;
    }
    
    /* Hide scrollbar for IE, Edge and Firefox */
    .expandable-cards-section .cards-wrapper {
      -ms-overflow-style: none;  /* IE and Edge */
      scrollbar-width: none;  /* Firefox */
    }
    
    /* Both desktop and mobile should have the same behavior */
    @media (min-width: 768px) {
      .expandable-cards-section .card-collapsed {
        width: 500px;
      }
      
      .expandable-cards-section .card-expanded {
        width: 900px;
      }
      
      .expandable-cards-section .card-wrapper {
        height: 600px !important;
      }
    }
    
    /* Mobile specific sizes but same slider behavior */
    @media (max-width: 767px) {
      .expandable-cards-section .card-collapsed {
        width: 340px;
      }
      
      .expandable-cards-section .card-expanded {
        width: 370px;
      }
      
      .expandable-cards-section .card-wrapper {
        height: 826px !important;
      }
    }
    
    @media (min-width: 768px) {
      .expandable-cards-section .card-wrapper {
        height: 600px !important;
      }
    }
    
    /* Hover effects */
    .expandable-cards-section .expand-btn:hover {
      // background-color: #f8f8f8;
    } 
  `;
  document.head.appendChild(style);

  function initExpandableCards() {
    const sections = document.querySelectorAll(".expandable-cards-section");

    sections.forEach(function (section) {
      const cards = section.querySelectorAll(".card-item");

      cards.forEach(function (card, cardIndex) {
        const expandBtn = card.querySelector(".expand-btn");

        if (expandBtn) {
          expandBtn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();

            const cardItem = this.closest(".card-item");
            const expandableContent = cardItem.querySelector(
              ".expandable-content"
            );

            const isExpanded = cardItem.classList.contains("card-expanded");

            if (!isExpanded) {
              // Collapse any other expanded cards in this section
              const otherExpandedCards = section.querySelectorAll(
                ".card-item.card-expanded"
              );
              otherExpandedCards.forEach(function (otherCard) {
                if (otherCard !== cardItem) {
                  collapseCard(otherCard);
                }
              });

              // Expand this card
              expandCard(cardItem);
            } else {
              // Collapse this card
              collapseCard(cardItem);
            }
          });
        }
        
        // Make entire card clickable
        card.addEventListener("click", function(e) {
          // Ignore clicks on buttons and links
          if (e.target.closest('a') || e.target.closest('button')) {
            return;
          }
          
          const expandBtn = this.querySelector(".expand-btn");
          if (expandBtn) {
            expandBtn.click();
          }
        });
      });
    });
  }



  function expandCard(cardItem) {
    cardItem.classList.remove("card-collapsed");
    cardItem.classList.add("card-expanded");

    const expandableContent = cardItem.querySelector(".expandable-content");
    if (expandableContent) {
      // Force a reflow to ensure the transition works
      expandableContent.style.display = "block";
      expandableContent.offsetHeight;

      setTimeout(function () {
        expandableContent.style.maxHeight = "200px";
        expandableContent.style.opacity = "1";
      }, 50);
    }

    // Add expanded state visual feedback
    const expandBtn = cardItem.querySelector(".expand-btn");
    if (expandBtn) {
      expandBtn.style.transform = "scale(1.1)";
      // Keep solid white background
      expandBtn.style.backgroundColor = "";
    }
  }

  function collapseCard(cardItem) {
    cardItem.classList.remove("card-expanded");
    cardItem.classList.add("card-collapsed");

    const expandableContent = cardItem.querySelector(".expandable-content");
    if (expandableContent) {
      expandableContent.style.maxHeight = "0";
      expandableContent.style.opacity = "0";
    }

    // Reset expand button
    const expandBtn = cardItem.querySelector(".expand-btn");
    if (expandBtn) {
      expandBtn.style.transform = "scale(1)";
      // Keep solid white background
      expandBtn.style.backgroundColor = "";
    }
  }

  function initCarousel() {
    const sections = document.querySelectorAll(".expandable-cards-section");

    sections.forEach(function (section) {
      const cardsWrapper = section.querySelector(".cards-wrapper");
      const cardsContainer = section.querySelector(".cards-container");
      const cards = section.querySelectorAll(".card-item");
      const prevBtn = section.querySelector(".nav-prev");
      const nextBtn = section.querySelector(".nav-next");
      const dotsContainer = section.querySelector(".flex.gap-2"); // The dots container div
      
      // Force reset of slider position
      if (cardsContainer) {
        cardsContainer.style.transform = 'translateX(0)';
      }

      if (!cardsContainer || cards.length === 0) {
        return;
      }

      let currentSlide = 0;

      // Calculate cards per view based on actual dimensions
      function calculateCardsPerView() {
        const containerWidth = cardsWrapper.offsetWidth;
        // Use widths based on screen size
        let cardWidth = window.innerWidth < 768 ? 280 : 500;
        const gap = 16; // gap between cards (gap-4 = 16px)
        const cardsPerView = Math.floor(containerWidth / (cardWidth + gap));
        return Math.max(1, cardsPerView);
      }

      let cardsPerView = calculateCardsPerView();
      let maxSlides = Math.max(0, cards.length - cardsPerView);
      let isTransitioning = false;

      // Initialize all cards as collapsed with specific dimensions
      cards.forEach(function (card, index) {
        card.classList.add("card-collapsed");
        
        // Make the first card expanded by default
        if (index === 0) {
          expandCard(card);
        }
      });

      // Work with existing dots instead of creating new ones
      const existingDots = dotsContainer
        ? dotsContainer.querySelectorAll(".dot")
        : [];

      // Add click event listeners to existing dots
      existingDots.forEach(function (dot, index) {
        // Make the first dot active by default
        if (index === 0) {
          dot.className = "w-2 h-2 transition-all duration-300 scale-125 bg-black rounded-full dot hover:scale-125";
        } else {
          dot.className = "w-2 h-2 transition-all duration-300 rounded-full bg-black/20 dot hover:scale-125";
        }
        
        dot.addEventListener("click", function () {
          goToSlide(index);
        });
      });

      // Only create dots if none exist and we need sliding
      if (
        !existingDots.length &&
        dotsContainer &&
        cards.length > cardsPerView
      ) {
        // Create dots for each slide position
        for (let i = 0; i <= maxSlides; i++) {
          const dot = document.createElement("button");
          dot.className = `dot w-3 h-3 rounded-full transition-all duration-300 hover:scale-125`;
          if (i === 0) {
            dot.classList.add("bg-black", "scale-125");
          } else {
            dot.classList.add("bg-black/20");
          }
          dot.setAttribute("data-slide", i.toString());

          dot.addEventListener("click", function () {
            goToSlide(i);
          });

          dotsContainer.appendChild(dot);
        }
      }

      function goToSlide(slideIndex) {
        if (slideIndex < 0 || slideIndex > maxSlides || isTransitioning) {
          return;
        }

        isTransitioning = true;
        currentSlide = slideIndex;

        // Collapse all cards before sliding
        cards.forEach(function(card) {
          if (card.classList.contains('card-expanded')) {
            collapseCard(card);
          }
        });

        // Calculate slide width based on actual card width
        let cardWidth = window.innerWidth < 768 ? 280 : 500; // Default based on screen size
        if (cards.length > 0) {
          const firstCard = cards[0];
          cardWidth = firstCard.offsetWidth || cardWidth;
        }
        const gap = 16;
        const slideWidth = cardWidth + gap;
        const translateX = -(currentSlide * slideWidth);

        cardsContainer.style.transform = `translateX(${translateX}px)`;

        // Update dots
        const allDots = dotsContainer.querySelectorAll(".dot");
        allDots.forEach(function (dot, index) {
          if (index === currentSlide) {
            dot.className =
              "w-4 h-4 transition-all duration-300 scale-125 bg-black rounded-full dot hover:scale-125";
          } else {
            dot.className =
              "w-4 h-4 transition-all duration-300 rounded-full bg-black/20 dot hover:scale-125";
          }
        });

        // Update nav buttons
        if (prevBtn) {
          prevBtn.disabled = currentSlide === 0;
          if (currentSlide === 0) {
            prevBtn.style.opacity = "0.5";
          } else {
            prevBtn.style.opacity = "1";
          }
        }

        if (nextBtn) {
          nextBtn.disabled = currentSlide >= maxSlides;
          if (currentSlide >= maxSlides) {
            nextBtn.style.opacity = "0.5";
          } else {
            nextBtn.style.opacity = "1";
          }
        }

        // Reset transition flag after animation
        setTimeout(function () {
          isTransitioning = false;
        }, 500);
      }

      // Handle mobile scroll
      let touchStartX = 0;
      let touchEndX = 0;
      
      cardsWrapper.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      
      cardsWrapper.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, { passive: true });
      
      function handleSwipe() {
        const swipeThreshold = 50;
        if (touchEndX < touchStartX - swipeThreshold) {
          // Swipe left - next slide
          if (currentSlide < maxSlides) {
            goToSlide(currentSlide + 1);
          }
        } else if (touchEndX > touchStartX + swipeThreshold) {
          // Swipe right - previous slide
          if (currentSlide > 0) {
            goToSlide(currentSlide - 1);
          }
        }
      }

      // Disable navigation if no sliding needed
      if (cards.length <= cardsPerView) {
        if (prevBtn) {
          prevBtn.style.opacity = "0.3";
          prevBtn.disabled = true;
        }
        if (nextBtn) {
          nextBtn.style.opacity = "0.3";
          nextBtn.disabled = true;
        }
        return;
      }

      // Navigation event listeners
      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          goToSlide(currentSlide - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          goToSlide(currentSlide + 1);
        });
      }

      // Window resize handler
      window.addEventListener("resize", function () {
        const newCardsPerView = calculateCardsPerView();
        if (newCardsPerView !== cardsPerView) {
          cardsPerView = newCardsPerView;
          maxSlides = Math.max(0, cards.length - cardsPerView);

          // Reset to first slide
          currentSlide = 0;
          goToSlide(0);
        }
      });
    });
  }
})();
